export default __webpack_public_path__ + "static/media/177.3f104fe2.png";